/* YUNAIKO — mesure.
   Les événements standard (product_viewed, product_added_to_cart, cart_viewed, checkout_started,
   checkout_completed, search_submitted…) sont déjà émis par Shopify vers les pixels (Meta, GA4, TikTok).
   Ce fichier n'en duplique aucun : il publie seulement des événements personnalisés que Shopify
   ne connaît pas, via Shopify.analytics.publish, lisibles par un pixel personnalisé (Réglages > Événements clients). */
(() => {
  function track(name, data = {}) {
    const payload = Object.assign({ page_type: document.body.dataset.pageType || '' }, data);
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(`yk_${name}`, payload);
      }
    } catch (e) { /* aucune mesure ne doit bloquer la navigation */ }
    document.dispatchEvent(new CustomEvent('yk:track', { detail: { name, data: payload } }));
  }
  window.ykTrack = track;

  document.addEventListener('click', (e) => {
    const tracked = e.target.closest('[data-yk-track]');
    if (tracked) {
      track(tracked.dataset.ykTrack, { label: (tracked.textContent || '').trim().slice(0, 80), href: tracked.getAttribute('href') || '' });
    }
    const card = e.target.closest('.card-wrapper a[href*="/products/"], .yk-card a[href*="/products/"]');
    if (card) {
      const list = card.closest('[data-yk-list]');
      track('select_item', { href: card.getAttribute('href'), list: list ? list.dataset.ykList : '' });
    }
  });

  /* Ouverture du tiroir panier = « view_cart » (Shopify ne l'émet que sur la page /cart) */
  const drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    let open = drawer.classList.contains('active');
    new MutationObserver(() => {
      const nowOpen = drawer.classList.contains('active');
      if (nowOpen && !open) track('view_cart', { source: 'drawer' });
      open = nowOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.querySelector('input[name="contact[tags]"][value*="newsletter"]')) {
      track('newsletter_submit', { form: form.id || '' });
    }
  });
})();
